import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'


import { SENSOR_DEVICE } from '../../constants/routes'
import { isDefaultSensorImage } from '../utilities/helpers'
import {
    DeviceListItem,
    DeviceBatteryIcon,
    DeviceBatteryIconWrapper,
    DeviceBatteryIconText,
    DeviceListImage,
    DeviceListItemContent,
    DeviceItemName,
    DeviceMoistureIconWrapper,
    DeviceMoistureIconText,
    DeviceMoistureIcon,
    DeviceListItemInnerContent,
    DevicesListItemCol
} from '../StyledComponents/Devices/DeviceList'

const batteryGreen = require('../../assets/images/DevicesList/batteryGreen.svg')
const batteryOrange = require('../../assets/images/DevicesList/batteryOrange.svg')
const batteryRed = require('../../assets/images/DevicesList/batteryRed.svg')
const sensorImage = require('../../assets/images/DevicesList/sensor.png')
const moistureIcon = require('../../assets/images/CareIcons/005-drop.png')

class SensorListItem extends Component {
    render() {
        const { sensor } = this.props
        const { soc } = sensor

        let batteryIcon = null
        let batteryColor = 'black'
        if (soc < 20) {
            batteryIcon = batteryRed
            batteryColor = 'danger'
        } else if (soc < 50) {
            batteryIcon = batteryOrange
            batteryColor = 'warning'
        } else {
            batteryIcon = batteryGreen
            batteryColor = 'success'
        }

        const image = isEmpty(sensor.image) ? sensorImage : sensor.image

        return (
            <DevicesListItemCol xs="6" sm="4" md="3">
                <DeviceListItem to={SENSOR_DEVICE.replace(':uuid', sensor.uuid)}>
                    <DeviceListItemContent>
                        <DeviceListImage src={image} contain={isDefaultSensorImage(sensor.image)} />
                        <DeviceListItemInnerContent>
                            <DeviceItemName>{sensor.name}</DeviceItemName>
                            <DeviceBatteryIconWrapper bottom="5">
                                <DeviceBatteryIcon image={batteryIcon} />
                                <DeviceBatteryIconText textColor={batteryColor}>
                                    {sensor.soc}%
                                </DeviceBatteryIconText>
                            </DeviceBatteryIconWrapper>
                            <DeviceMoistureIconWrapper bottom="5">
                                <DeviceMoistureIcon image={moistureIcon} />
                                <DeviceMoistureIconText>
                                    {sensor.current_moisture}%
                                </DeviceMoistureIconText>
                            </DeviceMoistureIconWrapper>
                        </DeviceListItemInnerContent>
                    </DeviceListItemContent>
                </DeviceListItem>
            </DevicesListItemCol>
        )
    }
}

export default SensorListItem



// WEBPACK FOOTER //
// ./src/components/Devices/SensorListItem.js